import React from 'react';
import { Box, Text, Card, Inset, Link, Button  } from '@radix-ui/themes';
//import { } from '@radix-ui/react-icons';

function checkSreenInf750() {
    const width = window.innerWidth;
    if(width < 750) return true;
    else return false;
}

const ArticlesSimple = (articleData) => {

    const d = articleData.articleData;


    function redirectToWebPage(url) {
        navigator.clipboard.writeText(url).then(function() {
            console.log('Async: Copying to clipboard was successful!');
            alert("Link copied to clipboard")
        }, function(err) {
            console.error('Async: Could not copy text: ', err);
        });
    }

    function getRandomString() {
        var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var result = '';
        for ( var i = 0; i < 10; i++ ) {
            result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
        }
        return result;
    }

    const token = getRandomString();

    if(!d) return <></>

    return <Box style={{height: '100%', width: checkSreenInf750() ? "100%" : "32%", display: "block"}} id={token}>
        <Box style={{height: '100%', width: checkSreenInf750() ? "96%" : "90%", display: "block", marginBottom: "10px"}}>
        
            <Link href={
                checkSreenInf750() ?
                '#'+token
                :
                d.usht_sht
            } style={{textDecoration: 'none', color: "black"}} target={
                checkSreenInf750() ?
                ''
                :
                "_blank"
            }>
                <Card size="2">
                    <Inset clip="padding-box" side="top" pb="current">
                        <img
                        src={d.newsraw_illu}
                        alt={d.newsraw_illu.split('://')[1].split('/')[0]}
                        style={{
                            display: 'block',
                            objectFit: 'cover',
                            width: '100%',
                            height: 140,
                            backgroundColor: 'var(--gray-5)',
                        }}
                        />
                    </Inset>
                    <Text as="p" size="2" color='gray'>
                        {d.newsraw_source}
                    </Text>
                    <Text as="p" size="3" weight="bold">
                        {d.newspro_trlstitle}
                    </Text>
                    <Text as="p" size="2">
                        {(d.newspro_body)}{/*.slice(0, 250) + '...').replace('......', '...')*/}
                    </Text>


                    {
                        checkSreenInf750() ? 
                        <Button onClick={() => redirectToWebPage(d.usht_sht)} style={{marginTop: "10px", backgroundColor: "#000000"}}>
                            {
                                d.newspro_lang === "FR" ?
                                    "Copier le lien" :
                                    "Copy link"
                            }
                        </Button>
                        :
                        <></>
                    }
                </Card>
            </Link>

        </Box>
    </Box>
}

export default ArticlesSimple;